import React, { useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import clsx from "clsx";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";
import { useHistory } from "react-router-dom";
import Hidden from "@material-ui/core/Hidden";
import CloseIcon from "@material-ui/icons/Close";
import { IconButton } from "@material-ui/core";
import { Accordion, AccordionSummary, AccordionDetails } from "@material-ui/core";

import { getSurveySections } from "../../actions/survey-actions";
import { Coin, ProgressBarSurvey } from "../shared/component";
import SurveyListHolder from "../survey/SurveyListHolder";
import Loading from "../shared/Loading";
import SurveyMilestone from "./SurveyMilestone";

import useStyles from "../../styles/components/survey/stylesSurvey";
import { ConvertDateString } from "../../utils/helpers/dateformat/ConvertDateString";
import { SnapShotSurveyData } from "../../utils/services/cache/ClientCache";


const SurveyHolderDetail = ({ survey, setOpenDetail }) => {
    const history = useHistory();
    const classes = useStyles();
    const [surveyWithHistoryList, SetSurveyWithHistoryList] = React.useState([]);
    const [loading, setLoading] = React.useState(true)
    let surveyId = survey.surveyId;
    let isClosed = false;

    SnapShotSurveyData.removeSnapShotSurveyData();

    if (!surveyId) return <Loading />;

    useEffect(() => {
        let today = new Date();
        let endDate = new Date(ConvertDateString.convertForDatePicker(survey.endDate));
        if (today > endDate) {           
            isClosed = true
        }
        
        initSurveyList();
        setLoading(false)
    }, []);

    const initSurveyList = async () => {
        let response = await getSurveySections(surveyId);
        if (response > 200 || response.status === "Failed") {
            return history.push("/SessionTimeOut")
        }

        if (response.status === "Success") {
            let sectionList = response.data.sectionModels;
            let historyList = response.data.sectionHistories;

            let surveyWithHistoryList = [];
            let count = 0;

            sectionList.forEach((section) => {
                let surveyWithHistory = {
                    completed: false,
                    snapshot: section,
                    history: null,
                    isClosed,
                };
                surveyWithHistoryList.push(surveyWithHistory);
            });

            for (let i = 0; i < historyList.length; i++) {
                let history = historyList[i];

                for (let j = 0; j < sectionList.length; j++) {
                    if (
                        history.sectionId === sectionList[j].id &&
                        history.surveyId === parseInt(surveyId)
                    ) {
                        count++;
                        surveyWithHistoryList[j].completed = true;
                        surveyWithHistoryList[j].history = history;
                        break;
                    }
                }
            }

            SnapShotSurveyData.setSurveySectionCompletedCount(count);
            SnapShotSurveyData.setSurveySectionCount(surveyWithHistoryList.length);
            const surveyProcessBar = {
                title: survey.title,
                date: survey.date,
                coin: survey.totalPoint,
                progressPercent: survey.progressPercent,
                milestonePercent: survey.milestonePercent,
                bonusPoint: survey.bonusPoint,
                noreward: survey.noreward,
                missed: survey.missed,
                position: survey.position
            }
            SnapShotSurveyData.setSurveyProcessBar(JSON.stringify(surveyProcessBar));

            SetSurveyWithHistoryList(surveyWithHistoryList);
        }
    };

    const handleExit = () => setOpenDetail(false);

    if (surveyWithHistoryList.length <= 0) <Loading />;

    return (
        <div style={{ width: "100%", padding: "0 20px 20px" }}>
            {loading && <Loading customClass="customSpinner" />}
            {!loading &&
                <>
                    <Hidden mdDown>
                        <IconButton
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            onClick={handleExit}
                            classes={{ root: classes.rootIcon }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Hidden>
                    <Hidden mdDown>
                        <Accordion
                            expanded={true}
                            classes={{ root: classes.rootAccordionInformation }}
                        >
                            <AccordionSummary
                                classes={{
                                    root: classes.rootAccordionSummaryInformation,
                                    content: classes.contentAccordionSummary,
                                }}
                            >
                                <Grid
                                    item xs={12}
                                    container
                                    justify="center"
                                    alignItems="center"
                                    classes={{ root: classes.rootGridContent }}
                                >
                                    <Grid item xs={12}>
                                        <div className={clsx(classes.textTitle)}> {survey.title} </div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div className={clsx(classes.textDescription)}> {survey.date} </div>
                                    </Grid>
                                </Grid>
                            </AccordionSummary>
                            <AccordionDetails
                                classes={{ root: classes.rootAccordionDetailsSurvey }}
                            >
                                <Grid
                                    item xs={12}
                                    container
                                    justify="center"
                                    alignItems="center"
                                    classes={{ root: classes.rootGridContent }}
                                >
                                    <Grid item xs={12} classes={{ root: classes.wrapperProrgessBarCoin }}>
                                        {new Date() <=
                                            new Date(
                                                ConvertDateString.convertForDatePicker(survey.endDate)
                                            ) && (
                                                <div className={clsx(classes.rootCoin)}>
                                                    <Coin coin={survey.totalPoint} size="medium" />
                                                </div>
                                            )}                         
                                    </Grid>
                                </Grid>
                            </AccordionDetails>
                        </Accordion>
                    </Hidden>

                    {new Date() <=
                        new Date(ConvertDateString.convertForDatePicker(survey.endDate)) && (
                            <Accordion
                                defaultExpanded={true}
                                classes={{
                                    root: classes.rootAccordion,
                                    expanded: classes.expandedAccordion,
                                    rounded: classes.roundedAccordion,
                                }}
                            >
                                <AccordionSummary
                                    classes={{
                                        root: classes.rootAccordionSummarySurveyDetail,
                                        content: classes.contentAccordionSummaryMilestone,
                                        expanded: classes.expandedAccordionSummarySurveyDetail,
                                    }}
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography variant="body1" color="initial" classes={{ root: classes.rootTypographyPercent }}>
                                        Early Completion Bonus (ECB)
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails classes={{ root: classes.rootAccordionDetails }}>
                                    <Grid item sm={12} xs={12}>
                                        <SurveyMilestone milestones={survey.milestones} />
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        )}
                    <Typography variant="body1" gutterBottom classes={{ root: classes.rootTypographySection }}>
                        Survey Section
                    </Typography>
                    <Grid container justify="space-between" alignItems="center">
                        <Typography variant="body2" color="textSecondary" classes={{ root: classes.rootTypographyPercent }}>Section Title</Typography>
                        <Typography variant="body2" color="textSecondary" classes={{ root: classes.rootTypographyPercent }}>Status</Typography>
                        <Typography variant="body2" color="textSecondary" classes={{ root: classes.rootTypographyPercent }}>Coins Per Section</Typography>
                    </Grid>
                    <Card classes={{ root: classes.rootCard }}>
                        <div>
                            {surveyWithHistoryList.map((surveyWithHistory, index) => (
                                <SurveyListHolder
                                    key={index}
                                    surveyWithHistory={surveyWithHistory}
                                />
                            ))}
                        </div>
                    </Card>
                </>
            }
        </div>
    );
};

export default SurveyHolderDetail;

//<ProgressBarSurvey
//    progressPercent={survey.progressPercent}
//    milestonePercent={survey.milestonePercent}
//    bonusPoint={survey.bonusPoint}
//    noreward={survey.noreward}
//    missed={survey.missed}
//    toolTipCoin={false}
//    position={survey.position}
///>

//<Typography variant="body1" color="textSecondary" gutterBottom className={clsx(classes.rootTypographyPercent, classes.typographyPercent)}>
//    Survey Completion Progress: {survey.progressPercent}%
//</Typography>